<template>
  <div
    :style="{opacity: opacity}"
    class="skeleton__container"
    :class="{'skeleton__container--no-bg': noBackground}"
  >
    <slot>
      <div v-if="!none" class="skeleton__item" />
      <div v-if="!single && !none" class="skeleton__item" />
    </slot>
  </div>
</template>

<script>
export default {
  name: 'BaseSkeleton',
  props: {
    opacity: {
      type: [Number, String],
      default: 1,
    },
    noBackground: {
      type: Boolean,
      default: false,
    },
    single: {
      type: Boolean,
      default: false,
    },
    none: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes pulse {
    0% {
        background: #eee;
    }
    50% {
        background: #ddd;
    }
    100% {
        background: #eee;
    }
}
.skeleton__container{
  background-color: #faf9f7;
  border-radius: 3px;
  padding: .5rem;
  margin-bottom: 0.5rem;
  width: 100%;
  &--no-bg{
    background-color: transparent;
    padding: 0;
  }
}
.skeleton__grid {
  display: grid;
  column-gap: 1rem;
  row-gap: 1rem;
  grid-template-columns: repeat(4, 1fr);

  &--2{
    grid-template-columns: repeat(2, 1fr);
  }

  &--3{
    grid-template-columns: repeat(3, 1fr);
  }

  &--4{
    grid-template-columns: repeat(4, 1fr);
  }

  &--5{
    grid-template-columns: repeat(5, 1fr);
  }

  &--6{
    grid-template-columns: repeat(6, auto);
  }
}
.skeleton__item {
  height: 0.8rem;
  background: #eee;
  width: 100%;
  animation: pulse 5s infinite;
  & + &{
    margin-top: 0.5rem;
  }
}
.skeleton__circle{
  width: 100%;
  max-width: 50px;
  height: 50px;
  border-radius: 50px;
  background: #eee;
  animation: pulse 5s infinite;
  &--large{
    max-width: 84px;
    height: 84px;
    border-radius: 84px;
  }
}
</style>
